import { SingleSelection } from "../GeneralSelection";
import { SelectChangeEvent } from "../MuiGenerals";
import useTranslation from "src/hooks/useTranslation";
import useQuerySpenderAddress from "./hooks/useQuerySpenderAddress";

function SpenderAddressSingleSelection({
  chainName,
  currency: assetName,
  value,
  fieldName,
  onChange,
  onClear,
}: {
  chainName: string;
  currency: string;
  value: string;
  fieldName: string;
  onChange: (e: SelectChangeEvent<string>) => void;
  onClear?: () => void;
}) {
  const { tc } = useTranslation("common");

  const { spenderAddressesSelectOptions } = useQuerySpenderAddress({
    chainName,
    assetName,
  });

  return (
    <SingleSelection
      value={value}
      label={tc("phSelection", { fieldName })}
      onChange={onChange}
      enumData={spenderAddressesSelectOptions}
      nameFn={(name) => name}
      clearSelect={onClear || (() => {})}
    />
  );
}

export default SpenderAddressSingleSelection;
